import React from "react";
import "./Footer.css";
import logo from "../assets/logo.png"; // Update with your logo path

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-shape"></div>
      <div className="footer-container">
        <div className="footer-column">
          <img src={logo} alt="Globus Trading Logo" className="footer-logo" />
          <p className="footer-text">
            Behind the word mountains, far from the countries Vokalia and
            Consonantia, there.
          </p>
        </div>
        <div className="footer-column">
          <h3>Useful Links</h3>
          <ul className="footer-links">
            <li>Home</li>
            <li>About</li>
            
            <li>Legal Documents</li>
            <li>Accounts</li>
            <li>Contact Us</li>
            
          </ul>
        </div>
        <div className="footer-column">
          <h3>Globus Trading</h3>
          <p>
            <strong>Registration Number:</strong> HT00324021
          </p>
          <p>
            <strong>License Number:</strong> BFX2024059
          </p>
          <p>
            <strong>Registered Office:</strong> Bonovo Road – Fomboni Island of
            Mohéli – Comoros Union
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="risk-warning">
          <strong>Risk warning: </strong>Trading foreign exchange on margin
          carries a high level of risk, and may not be suitable for all
          investors. Before deciding to trade foreign exchange, you should
          carefully consider your investment objectives, level of experience,
          and risk appetite. You should be aware of all the risks associated
          with foreign exchange trading, and seek advice from an independent
          financial advisor if you have any doubts.
        </p>
        <p className="copyright">
          ©2024 Globus Trading. ALL RIGHTS RESERVED.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
